import { InputValid } from '~components'
import * as Styled from './styled'

function Success({ children }) {
  return (
    <Styled.PopoverSuccess>
      <InputValid />
      {children}
    </Styled.PopoverSuccess>
  )
}

export default Success
